import { onAuthStateChanged, signOut } from 'firebase/auth';
import { auth } from '../utils/firebase.js';
import { useEffect, } from 'react';
import { useNavigate } from "react-router-dom";
import { postSignInCheck } from '../data/users.js';
import { useAuthStore } from '../stores/useAuthStore.js';

function AuthenticationButtons(props) {
    const navigate = useNavigate();
    const {
        user,
        setUser,
        logout,
        setLoading,
        lastLoginWritePerformed,
        setLastLoginWritePerformed
    } = useAuthStore();
    const { setMustAgreeToTerms } = useAuthStore();

    const logOut = async () => {
        signOut(auth)
            .then(() => {
                logout();
                navigate('/');
            })
            .catch((error) => {

            });
    }

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (firebaseUser) => {
            setUser(firebaseUser);
            setLoading(false);
            if (firebaseUser) {
                if (!lastLoginWritePerformed) {
                    postSignInCheck(firebaseUser.uid, setMustAgreeToTerms)
                        .then(() => {
                            setLastLoginWritePerformed(true);
                        });
                }
            } else {
                logout();
            }
        });

        // Cleanup subscription on unmount
        return () => unsubscribe();
    }, [setUser, setLoading, postSignInCheck, logout, lastLoginWritePerformed, setLastLoginWritePerformed]);


    return (
        <>
            <div className="buttons">
                <button className={"button is-dark mt-0 " + (user ? "" : " is-hidden")} onClick={logOut} id="logoutButton">Log Out</button>
            </div>
        </>
    );
}

export default AuthenticationButtons;